__turbopack_context__.v({
  "description": "LrIQOW_description",
});
